const PRIMARY_TOKEN_KEY = "authToken";
const LEGACY_TOKEN_KEY = "token";

const USER_METADATA_KEYS = ["userRole", "userName", "userEmail"];

export function normalizeToken(token) {
  if (typeof token !== "string") {
    return null;
  }

  const trimmed = token.trim();
  if (!trimmed) {
    return null;
  }

  const normalized = trimmed.replace(/^Bearer\s+/i, "").trim();
  return normalized || null;
}

export function getStoredToken() {
  try {
    return normalizeToken(
      localStorage.getItem(PRIMARY_TOKEN_KEY) ||
        localStorage.getItem(LEGACY_TOKEN_KEY)
    );
  } catch (error) {
    return null;
  }
}

export function getAuthHeader() {
  const token = getStoredToken();
  return token ? `Bearer ${token}` : null;
}

export function storeToken(token) {
  const normalized = normalizeToken(token);

  if (!normalized) {
    return null;
  }

  localStorage.setItem(PRIMARY_TOKEN_KEY, normalized);
  localStorage.removeItem(LEGACY_TOKEN_KEY);
  return normalized;
}

export function storeUserMetadata(user) {
  if (!user) {
    return;
  }

  if (user.role) {
    localStorage.setItem("userRole", user.role);
  }

  if (user.name) {
    localStorage.setItem("userName", user.name);
  }

  if (user.email) {
    localStorage.setItem("userEmail", user.email);
  }
}

export function clearStoredAuth() {
  localStorage.removeItem(PRIMARY_TOKEN_KEY);
  localStorage.removeItem(LEGACY_TOKEN_KEY);

  USER_METADATA_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });
}
